<ion-list *transloco="let t">
  <ion-item (click)="goToPrivacy()">{{t('common.menu.privacy')}}</ion-item>
  <ion-item (click)="logout()">{{t('common.menu.logout')}}</ion-item>
  <ion-item lines="none" (click)="handleDeleteAccount()"
    >{{t('auth.deleteAccount')}}</ion-item
  >
</ion-list>
